import React, { FC } from 'react';
import { Box } from '../Box';
import { Text } from '../Text';
import { TTextSize } from '../Text/models';
import { TColor } from '@src/models/common';

export interface ICaptionsProps {
  //пропс для передачи массива со сносками
  items: string[];
  //отмена переноса строки
  nowrap?: boolean;
  //определение размера сноски
  size?: TTextSize;
  //определение цвета
  color?: TColor;
}

export const Caption: FC<ICaptionsProps> = ({ items, nowrap, size = 'caption', color = 'basicGreySemiDark' }) => {
  return (
    <Box column gap={4}>
      {items.map((caption, index) => (
        <Text key={index} nowrap={nowrap} id={`${index}`} size={size} color={color}>
          [{index + 1}] {caption}
        </Text>
      ))}
    </Box>
  );
};
